export const RESUME_CACHE_STORAGE_KEY = 'trident-combined-resume-index';

export type ResumeCachePhase = 'prequal' | 'fullApp';

export interface ResumeCacheEntry {
  resumeLink: string;
  phase: ResumeCachePhase;
  sessionId: string;
  updatedAt: number;
}

type ResumeCacheIndex = Record<string, ResumeCacheEntry>;

const readResumeCacheIndex = (storage: Storage): ResumeCacheIndex => {
  try {
    const raw = storage.getItem(RESUME_CACHE_STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    console.error('[ResumeCache] Failed to read sessionStorage index:', error);
    return {};
  }
};

const writeResumeCacheIndex = (storage: Storage, index: ResumeCacheIndex): void => {
  try {
    storage.setItem(RESUME_CACHE_STORAGE_KEY, JSON.stringify(index));
  } catch (error) {
    console.error('[ResumeCache] Failed to write sessionStorage index:', error);
  }
};

export function writeResumeCacheEntry(
  imtId: string,
  phase: ResumeCachePhase,
  resumeLink: string,
  sessionId: string
): void {
  const index = readResumeCacheIndex(window.sessionStorage);
  index[imtId] = { resumeLink, phase, sessionId, updatedAt: Date.now() };
  writeResumeCacheIndex(window.sessionStorage, index);
}

// `storage` defaults to this window's own sessionStorage, but a caller may
// pass a DIFFERENT Storage instance (e.g. window.opener.sessionStorage) —
// needed because window.open() clones sessionStorage into the new tab at
// creation time, then the two tabs' storages are permanently disconnected.
// Deleting only from the current tab's (cloned) storage never reaches the
// original tab's storage, which is the one a later click will actually read.
export function deleteResumeCacheEntry(
  imtId: string,
  storage: Storage = window.sessionStorage
): void {
  const index = readResumeCacheIndex(storage);
  if (imtId in index) {
    delete index[imtId];
    writeResumeCacheIndex(storage, index);
  }
}
